<template>
  <div v-if="exibirBanner" class="cookie-consent-banner" data-cy="cookie-consent-banner">
    <div class="cookie-consent-banner__container">
      <p class="cookie-consent-banner__texto">
        Utilizamos cookies para oferecer uma melhor experiência de navegação. Ao aceitá-los, você
        terá acesso a todas as funcionalidades do site. Se rejeitá-los, os cookies que não forem
        estritamente necessários serão desativados. Saiba mais em:
        <a
          class="cookie-consent-banner__link"
          :href="urlPoliticaPrivacidade"
          target="_blank"
          rel="noopener"
        >Política de Privacidade e Cookies.</a>
      </p>

      <div class="cookie-consent-banner__botoes">
        <button type="button" class="cookie-consent-banner__botao--aceitar" @click="aceitar">
          Aceitar
        </button>
        <button type="button" class="cookie-consent-banner__botao--rejeitar" @click="rejeitar">
          Rejeitar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCookieConsent } from '@shared/cookie-consent/composables/useCookieConsent';

const { exibirBanner, aceitar, rejeitar } = useCookieConsent();
const urlPoliticaPrivacidade = appSettings.VUE_APP_URL_PRIVACIDADE;
</script>

<style scoped lang="scss">
@use "@/assets/styles/_functions.scss" as *;
@use "@/assets/styles/_vars" as *;

.cookie-consent-banner {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 6000;
  padding-bottom: $space-sm;
  font-size: px2rem(14px);
}

.cookie-consent-banner__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: $space-sm;
  width: 95%;
  max-width: 1200px;
  margin: 0 auto;
  padding: $space-xs $space-sm;
  border-radius: $border-radius;
  background: #fff;
  box-shadow: 0 7px 22px rgba(0, 0, 0, .2);

  @media (min-width: 768px) {
    flex-direction: row;
  }
}

.cookie-consent-banner__texto {
  margin: 0;
  text-align: center;

  @media (min-width: 768px) {
    text-align: left;
  }
}

.cookie-consent-banner__botoes {
  display: flex;
  flex: 0 0 auto;
  gap: $space-xxs;
  max-width: 100%;
}

.cookie-consent-banner__botoes button {
  flex: 1 1 0;
  min-width: 115px;
  padding: $space-xxs;
  border: 1px solid var(--acerto-colors-green-700, #0d5c3d);
  border-radius: 5px;
  background: transparent;
  color: var(--acerto-colors-green-700, #0d5c3d);
  font-size: px2rem(16px);
  font-weight: 600;
  cursor: pointer;
  transition: all $animation-duration-fast ease-in-out;
}

.cookie-consent-banner__botoes button:hover,
.cookie-consent-banner__botoes button:focus-visible {
  background: var(--acerto-colors-green-700, #0d5c3d);
  color: #fff;
}
</style>
